// src/pages/Appli/AppliAdmin/ListingClients/ui/FormField.jsx

import React from "react";

export const FORM_INPUT_CLASS = [
  "w-full rounded-xl border",
  "border-slate-300 dark:border-slate-700",
  "bg-white dark:bg-slate-950/60",
  "px-3 py-2.5",
  "text-sm text-slate-900 dark:text-slate-100",
  "placeholder:text-slate-400",
  "outline-none transition",
  "focus:border-violet-400 focus:ring-4 focus:ring-violet-500/10",
  "disabled:cursor-not-allowed disabled:opacity-60",
].join(" ");

export function getFormInputClass(hasError) {
  if (!hasError) return FORM_INPUT_CLASS;

  return [
    FORM_INPUT_CLASS,
    "!border-red-400",
    "focus:!border-red-500",
    "focus:!ring-red-500/10",
  ].join(" ");
}

export function FormField({
  label,
  required = false,
  error,
  hint,
  children,
  className = "",
}) {
  return (
    <div className={className}>
      <div className="mb-1.5 flex items-center justify-between gap-3">
        <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
          {label}

          {required ? (
            <span className="ml-1 text-red-500">*</span>
          ) : null}
        </label>

        {hint ? (
          <span className="text-xs text-slate-400">
            {hint}
          </span>
        ) : null}
      </div>

      {children}

      {error ? (
        <p className="mt-1.5 text-xs font-medium text-red-600 dark:text-red-400">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function FormSection({
  title,
  description,
  icon: Icon,
  children,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-5 flex items-start gap-3">
        {Icon ? (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-100 text-violet-600 dark:bg-violet-500/15 dark:text-violet-300">
            <Icon />
          </div>
        ) : null}

        <div>
          <h3 className="font-semibold text-slate-900 dark:text-white">
            {title}
          </h3>

          {description ? (
            <p className="mt-0.5 text-xs leading-5 text-slate-500 dark:text-slate-400">
              {description}
            </p>
          ) : null}
        </div>
      </div>

      {children}
    </section>
  );
}